





















import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin, elementWidth } from '@/mixins'
import easyapi, { showSnackbar } from '@/easyapi'
import { OsdImage } from '@/types/api'
import { deepCopy } from '@/utils'
import { TranslateResult } from 'vue-i18n'

type crud_t = 'create' | 'edit'
const IMG_DEFAULT_FORM = {
  id: -1,
  name: '',
  fileName: '---',
  mask: false,
}

export default mixins(generalDialogMixin, elementWidth).extend({
  data (): {
    copiedForm: OsdImage,
    newImgUploaded: boolean,
    imgBlobUrl: string,
    imgBlob: Blob | null,
    formatInvalid: boolean,
    notVga: boolean,
    time: number
  } {
    return {
      copiedForm: IMG_DEFAULT_FORM,
      newImgUploaded: false,
      imgBlobUrl: '',
      imgBlob: null,
      formatInvalid: false,
      notVga: false,
      time: -1
    }
  },
  computed: {
    show (): boolean { return this.dialog.show },
    title (): TranslateResult { return this.crudType === 'create' ? this.$t('osdimg.create') : this.$t('osdimg.edit') },
    crudType (): crud_t {
      const name = this.$route.name
      if (!name) { return 'create' }
      if (name.includes('img_create')) { return 'create' }
      return 'edit'
    },
    imgSrc (): string {
      if (this.newImgUploaded) { return this.imgBlobUrl }
      if (this.crudType === 'edit') {
        return `/osd-images/${this.copiedForm.id}?time=${this.time}`
      }
      return ''
    },
    imgSize (): {width: number, height: number} {
      const w = ~~this.elementWidthDict['imgOuter']
      return {
        width: w,
        height: w * (480 / 640)
      }
    },
    imgStyle (): string {
      const p = this.imgSize
      return `width: ${p.width}px; height: ${p.height}px;`
    },
    nameDupliacted (): boolean {
      if (this.crudType === 'create') {
        return !!this.$s.$state.device.osd.imgList.find(x => x.name === this.copiedForm.name)
      } else {
        return !!this.$s.$state.device.osd.imgList
        .filter(x => x.id !== this.copiedForm.id)
        .find(x => x.name === this.copiedForm.name)
      }
    },
    disableApply (): boolean {
      if (!this.copiedForm.name) { return true }
      return this.nameDupliacted
    },
  },
  methods: {
    tryToPreviewFile () {
      this.formatInvalid = false
      this.notVga = false
      const fileInput = this.$refs.fileInput as HTMLInputElement
      const files = fileInput.files
      if (!files) {return}
      const file = files[0]
      if (!file) {return}
      if (!['image/png', 'image/jpeg', 'image/pjpeg'].includes(file.type)) {
        this.formatInvalid = true
        return
      }
      const reader  = new FileReader()
      reader.addEventListener('load', () => {
        this.newImgUploaded = true
        const arrBuf = reader.result as ArrayBuffer
        URL.revokeObjectURL(this.imgBlobUrl)
        this.imgBlob = new Blob([arrBuf])
        this.imgBlobUrl = URL.createObjectURL(this.imgBlob)
        const previewImg = this.$refs.img as HTMLImageElement
        if (previewImg.naturalWidth !== 640 || previewImg.naturalHeight !== 480) {
          this.notVga = true
        }
      }, false)

      if (file) {
        reader.readAsArrayBuffer(file)
      }
    },
    prepareVmData () {
      this.newImgUploaded = false
      if (this.crudType === 'create') {
        this.copiedForm = deepCopy(IMG_DEFAULT_FORM)
      } else {
        const tmp = this.$state.device.osd.imgList.find(x => x.id === ~~this.$route.params['imgid'])
        if (!tmp) { console.error('[To Developer] Impossible'); return }
        this.copiedForm = deepCopy(tmp)
      }
      this.time = Date.now()
    },
    async apply () {
      if (this.crudType === 'create') {
        let ok: boolean
        if (!this.imgBlob) { console.error('[To Developer] Impossible'); return }
        ok = await easyapi.uploadImageFile(this.imgBlob)
        if (!ok) { showSnackbar('Upload failed', 'error'); return }
        ok = await easyapi.createOrModifyImageConfig(this.copiedForm, 'create')
        if (!ok) { showSnackbar('Failed while writing info', 'error'); return }
        showSnackbar(this.$t('msg.applyDone'), 'success')
      } else {
        let ok: boolean
        if (this.newImgUploaded) {
          if (!this.imgBlob) { console.error('[To Developer] Impossible'); return }
          ok = await easyapi.uploadImageFile(this.imgBlob, this.copiedForm.id)
          if (!ok) { showSnackbar('Upload failed', 'error'); return }
        }
        ok = await easyapi.createOrModifyImageConfig(this.copiedForm, 'modify')
        if (!ok) { showSnackbar('Failed while writing info', 'error'); return }
        showSnackbar(this.$t('msg.applyDone'), 'success')
      }
      this.closeThisDialog()
      URL.revokeObjectURL(this.imgBlobUrl)
      this.imgBlobUrl = ''
      this.imgBlob = null
    }
  },
  mounted () {
    this.prepareVmData()
    this.watchElementWidth('imgOuter', ['show'])
  },
  watch: {
    show (nv: boolean) {
      if (nv) { this.prepareVmData() }
    }
  }
})
